export default {
      id: "facebook-circle-usage",
      viewBox: "0 0 980 980",
      url: __webpack_public_path__ + "icons-sprite.ef97e87.svg#facebook-circle-usage",
      toString: function () {
        return this.url;
      }
    }